import { Column, CreateDateColumn, Entity, PrimaryColumn, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";

@Entity('cron_info', { schema: 'public' })
export class CronInfo{
    @PrimaryGeneratedColumn('increment', {name: 'id'})
    id: number;

    @Column('varchar',{
        name:'module',
        length:50
    })
    module : string

    @Column('text',{
        name: 'description',
    })
    description : string

    @Column('boolean',{
        name:'status'
    })
    status : boolean

    @Column('varchar',{
        name :'reason',
        length : 100
    })
    reason : string

    @CreateDateColumn({
        name: "created_at",
        type:"datetime"
      })
      createdAt: Date;

      @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;


}